export { default } from './assignIn.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/extend.js
// module id = 633
// module chunks = 67